import { Link } from "react-router-dom";
import {
  CheckCircle2,
  ShieldCheck,
  WalletCards,
} from "lucide-react";

function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#07111f] text-white">
      {/* Background Glow */}
      <div className="pointer-events-none absolute -left-32 top-20 h-72 w-72 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-32 bottom-10 h-80 w-80 rounded-full bg-cyan-400/10 blur-3xl" />

      {/* Main Footer */}
      <div className="relative mx-auto max-w-7xl px-5 py-12 sm:px-6 lg:px-8 lg:py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr]">

          {/* Brand */}
          <div>
            <Link to="/" className="group inline-flex items-center gap-3">
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#00a96d] text-lg font-black text-white shadow-lg shadow-emerald-950/30 transition-transform duration-300 group-hover:-translate-y-1">
                R
              </div>

              <div>
                <div className="text-xl font-black tracking-[-0.04em]">
                  <span className="text-emerald-400">Refer</span>
                  <span className="text-white">x</span>
                </div>

                <div className="text-[9px] font-bold uppercase tracking-[0.18em] text-slate-500">
                  WhatsApp Automation
                </div>
              </div>
            </Link>

            <p className="mt-5 max-w-sm text-sm leading-7 text-slate-400">
              Automate WhatsApp campaigns, complete assigned tasks, refer
              eligible users, and manage performance-based earnings through
              Referx.
            </p>

            {/* Trust Items */}
            <div className="mt-7 space-y-3">
              <div className="flex items-center gap-3 text-xs font-semibold text-slate-300">
                <CheckCircle2 className="h-4 w-4 text-emerald-400" />
                Verified Performance
              </div>

              <div className="flex items-center gap-3 text-xs font-semibold text-slate-300">
                <ShieldCheck className="h-4 w-4 text-emerald-400" />
                ₹200 Per Verified Purchase
              </div>

              <div className="flex items-center gap-3 text-xs font-semibold text-slate-300">
                <WalletCards className="h-4 w-4 text-emerald-400" />
                UPI Withdrawals
              </div>
            </div>
          </div>

          {/* Platform */}
          <div>
            <h3 className="text-xs font-black uppercase tracking-[0.16em] text-white">
              Platform
            </h3>

            <ul className="mt-5 space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Home
                </Link>
              </li>

              <li>
                <Link
                  to="/how-it-works"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  How It Works
                </Link>
              </li>

              <li>
                <Link
                  to="/tasks"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Tasks
                </Link>
              </li>

              <li>
                <Link
                  to="/refer-earn"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Refer & Earn
                </Link>
              </li>

              <li>
                <Link
                  to="/withdraw-rules"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Withdraw Rules
                </Link>
              </li>

              <li>
                <Link
                  to="/faq"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  FAQ
                </Link>
              </li>

              <li>
                <Link
                  to="/software"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Software
                </Link>
              </li>
            </ul>
          </div>

          {/* Account + Legal */}
          <div>
            <h3 className="text-xs font-black uppercase tracking-[0.16em] text-white">
              Account
            </h3>

            <ul className="mt-5 space-y-3">
              <li>
                <Link
                  to="/login"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Login
                </Link>
              </li>

              <li>
                <Link
                  to="/signup"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Create Account
                </Link>
              </li>

              <li>
                <Link
                  to="/dashboard"
                  className="text-sm text-slate-400 transition-colors hover:text-emerald-400"
                >
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-5 py-6 sm:px-6 md:flex-row md:items-center md:justify-between lg:px-8">

          <p className="text-xs leading-6 text-slate-500">
            © {new Date().getFullYear()} Referx. All rights reserved.
          </p>

          <p className="text-center text-[11px] leading-5 text-slate-500 md:text-right">
            Transparent performance-based earnings. Strictly ₹200 per
            verified software purchase. No fixed salary promises.
          </p>
        </div>
      </div>

      {/* Footer Animation */}
      <style>{`
        @keyframes footerGlow {
          0%,
          100% {
            opacity: 0.45;
            transform: scale(1);
          }
          50% {
            opacity: 0.7;
            transform: scale(1.05);
          }
        }
      `}</style>
    </footer>
  );
}

export default Footer;